module.exports = __webpack_public_path__ + "img/111_bones.bb0dcf28.jpg";